import { candidateConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

// create candidate
export const create_candidate_action = (data) => async (dispatch) => {
  dispatch({
    type: candidateConstants.CREATE_CANDIDATE_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(config.auth.onBoard, data);
    if (response.status) {
      const user = JSON.parse(localStorage.getItem("jigsawUser"));
      user.user.user_meta_info["phone"] = data.phone;
      localStorage.setItem("jigsawUser", JSON.stringify(user));
      dispatch({
        type: candidateConstants.CREATE_CANDIDATE_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateConstants.CREATE_CANDIDATE_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// update candidate profile
export const update_candidate_profile_action = (data) => async (dispatch) => {
  dispatch({
    type: candidateConstants.UPDATE_CANDIDATE_PROFILE_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(
      config.candidate.updateCandidateProfile,
      data
    );
    if (response.status) {
      showSuccessMessage("Successfully updated.");
      dispatch({
        type: candidateConstants.UPDATE_CANDIDATE_PROFILE_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateConstants.UPDATE_CANDIDATE_PROFILE_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//get candidate profile
export const get_candidate_profile_data_action = () => async (dispatch) => {
  dispatch({
    type: candidateConstants.GET_CANDIDATE_PROFILE_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.candidate.getCandidateProfileData
    );
    if (response.status) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_PROFILE_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_PROFILE_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//get candidate intro
export const get_candidate_intro_data_action = () => async (dispatch) => {
  dispatch({
    type: candidateConstants.GET_CANDIDATE_INTRO_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.candidate.getCandidateIntroData
    );
    if (response.status) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_INTRO_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_INTRO_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// get all educational data
export const get_candidate_all_educational_data_action =
  () => async (dispatch) => {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.candidate.getCandidateAllEducationData
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// get education by id
export const get_candidate_education_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.candidate.getCandidateEducationByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//update education by id
export const update_candidate_education_by_id_data_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.UPDATE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.candidate.getCandidateEducationByIdData.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.UPDATE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.UPDATE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//create new education
export const create_candidate_education_data_action =
  (data) => async (dispatch) => {
    dispatch({
      type: candidateConstants.CREATE_CANDIDATE_EDUCATION_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.candidate.createCandidateEducation,
        data
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.CREATE_CANDIDATE_EDUCATION_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.CREATE_CANDIDATE_EDUCATION_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//get all professional data
export const get_candidate_all_professional_data_action =
  () => async (dispatch) => {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.candidate.getCandidateAllProfessionalData
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//get profession by id
export const get_candidate_profession_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.candidate.getCandidateExperienceByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//update profession by id
export const update_candidate_profession_by_id_data_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.UPDATE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.candidate.getCandidateExperienceByIdData.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.UPDATE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.UPDATE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//create new profession data
export const create_candidate_profession_data_action =
  (data) => async (dispatch) => {
    dispatch({
      type: candidateConstants.CREATE_CANDIDATE_PROFESSION_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.candidate.createCandidateExperience,
        data
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.CREATE_CANDIDATE_PROFESSION_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.CREATE_CANDIDATE_PROFESSION_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//get all skills data
export const get_candidate_all_skills_data_action = () => async (dispatch) => {
  dispatch({
    type: candidateConstants.GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.candidate.getCandidateAllSkillsData
    );
    if (response.status) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//update profession by id
export const create_candidate_skills_data_action =
  (data) => async (dispatch) => {
    dispatch({
      type: candidateConstants.CREATE_CANDIDATE_SKILLS_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.candidate.createCandidateSkill,
        data
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.CREATE_CANDIDATE_SKILLS_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.CREATE_CANDIDATE_SKILLS_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//create new profession data
export const delete_candidate_skill_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.DELETE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.candidate.deleteCandidateSkillById.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.DELETE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.DELETE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//create new profession data
export const update_candidate_skill_by_id_data_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: candidateConstants.UPDATE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.candidate.deleteCandidateSkillById.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.UPDATE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.UPDATE_CANDIDATE_SKILL_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//delete education
export const delete_candidate_education_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.DELETE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.candidate.deleteCandidateEducationByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.DELETE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.DELETE_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//deletes experience
export const delete_candidate_profession_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.DELETE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.candidate.deleteCandidateExperienceByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.DELETE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.DELETE_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//get all portfolio urls
export const get_candidate_all_portfolio_data_action =
  () => async (dispatch) => {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.candidate.getCandidateAllPortfolioData
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//get portfolio url by id
export const get_candidate_portfolio_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.candidate.getCandidatePortfolioByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.GET_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//update portfolio url by id
export const update_candidate_portfolio_by_id_data_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.UPDATE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.candidate.updateCandidatePortfolio.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.UPDATE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.UPDATE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//create new portfolio url
export const create_candidate_portfolio_data_action =
  (data) => async (dispatch) => {
    dispatch({
      type: candidateConstants.CREATE_CANDIDATE_PORTFOLIO_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.candidate.createCandidatePortfolio,
        data
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.CREATE_CANDIDATE_PORTFOLIO_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.CREATE_CANDIDATE_PORTFOLIO_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e.msg);
    }
  };

//deletes portfolio url
export const delete_candidate_portfolio_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateConstants.DELETE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.candidate.deleteCandidatePortfolioByIdData.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.DELETE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.DELETE_CANDIDATE_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

// get all invited data
export const get_candidate_invited_jobs_action = (page) => async (dispatch) => {
  dispatch({
    type: candidateConstants.GET_CANDIDATE_INVITED_JOBS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      `${config.candidate.candidateInvitedJobsList}?page=${page ? page : 1}`
    );
    if (response.status) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_INVITED_JOBS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_INVITED_JOBS_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// get all suggested data
export const get_candidate_suggested_jobs_action =
  (page) => async (dispatch) => {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_SUGGESTED_JOBS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.candidateSuggestedJobsList}?page=${page ? page : 1}`
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.GET_CANDIDATE_SUGGESTED_JOBS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_SUGGESTED_JOBS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//get pending task
export const get_candidate_pending_task_action = () => async (dispatch) => {
  dispatch({
    type: candidateConstants.GET_CANDIDATE_PENDING_TASK_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.candidate.getCandidatePendingTask
    );
    if (response.status) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_PENDING_TASK_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_PENDING_TASK_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// get all invited data
export const get_candidate_interview_invites_action =
  () => async (dispatch) => {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.getCandidateInterviewInvites}`
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

export const get_candidate_accepted_interviews_action =
  () => async (dispatch) => {
    dispatch({
      type: candidateConstants.GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.getCandidateAcceptedInterviews}`
      );
      if (response.status) {
        dispatch({
          type: candidateConstants.GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateConstants.GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };
